<template>
    <v-dialog
    v-model="localValue"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
        {{active ? 'Deaktiviraj' : 'Aktiviraj'}} poslovno enoto
      </v-card-title>

      <v-card-text>
        <BusinessUnitActivationForm
          ref="businessUnitActivationForm"
          :requireNotes="active"
          @save="saveAndClose"
        />
      </v-card-text>

      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn
          color="blue-grey lighten-3"
          text
          @click="$emit('input', false)"
        >
          Prekliči
        </v-btn>

        <v-btn
          color="#0F998E"
          dark
          @click="$refs.businessUnitActivationForm.save()"
        >
          V redu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BusinessUnitActivationForm from './BusinessUnitActivationForm'

export default {
  components: {
    BusinessUnitActivationForm
  },
  props: {
    active: {
      required: true,
      type: Boolean
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      localValue: this.value
    }
  },
  methods: {
    saveAndClose (form) {
      this.$emit('input', false)
      this.$emit('confirmed', form)
    }
  },
  watch: {
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
